export default {
  title1: '专为国际学校设计的一体化',
  basics: '基础模块',
  title2: '管理平台',
  admission: '招生管理',
  curriculum: '备课系统 ',
  moments: '成长印记',
  livestream: '直播互动',
  adm_discrb: '线上管理新生报名信息、校园参观申请及入学测试记录，高效处理招生事宜。',
  curc_discrb: '引入CGC框架，从定义-设计-交付-评估四个纬度帮助老师更好的进行课程规划，并且可以进行课程分享和协作',
  moms_discrb: '多种方式（视频，照片，文档等）记录学生的活动和表现，让家长全方位了解孩子在学校的成长。',
  lvs_disscrb: '直播课程、体育活动、庆典等，让家长随时可以随时在线观看。',
  basics_discrb: '一个界面管理多个端口的数据，设置和授权。'
}



// WEBPACK FOOTER //
// ./src/views/home/lang/zh.js